import { render, staticRenderFns } from "./NormalMulti2.vue?vue&type=template&id=dc9eaeda&"
import script from "./NormalMulti2.vue?vue&type=script&lang=js&"
export * from "./NormalMulti2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports